module.exports = __webpack_public_path__ + "static/media/flavour-vinhoporto.547e1d5a.png";